module.exports = __webpack_public_path__ + "student_en@2x.7afdc82a.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Student/images/student_en@2x.png
// module id = tfRU
// module chunks = 0